import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorBase } from '@shared/bases/control-value-accessor.base';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-checkbox',
	imports: [SharedModule],
	templateUrl: './checkbox.component.html',
	styleUrl: './checkbox.component.scss',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CheckboxComponent),
			multi: true,
		},
	],
})
export class CheckboxComponent extends ControlValueAccessorBase<boolean> {
	@Input() size: 'small' | 'large' = 'large';
	@Input() disabled = false;
	@Input() label = '';
	@Input() error = false;
	@Input() helperText = '';
	checked = false;

	onValueChange(value: boolean): void {
		this.value = value;
		this.onTouched();
	}
}
